var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndeliveredShipments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 42,
    viewBox: "0 0 50 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_866_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8365 20.7056V41.8767L0.0356445 31.8904V10.5195L19.8365 20.7056Z",
    fill: "#DBB551"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.259 10.6172L39.8286 32.0879L19.7407 41.8745V21.2027L40.259 10.6172Z",
    fill: "#E7BF55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.0600586 10.6185L19.9321 21.1042L40.3069 10.6185L20.506 0.132812L-0.0600586 10.6185Z",
    fill: "#EFC75E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4022 16.5086L9.21875 6.02291L13.045 3.92578L33.3242 14.3116V20.8027L32.4632 21.302H31.5067L30.9327 22.3007H29.4022V16.5086Z",
    fill: "#F7E3AF",
    stroke: "#D6B764",
    strokeWidth: 0.458716
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8664 41.8773C44.0866 41.8773 49.9398 36.0241 49.9398 28.8039C49.9398 21.5836 44.0866 15.7305 36.8664 15.7305C29.6461 15.7305 23.793 21.5836 23.793 28.8039C23.793 36.0241 29.6461 41.8773 36.8664 41.8773Z",
    fill: "#F9FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8667 39.5831C42.8203 39.5831 47.6465 34.7568 47.6465 28.8033C47.6465 22.8497 42.8203 18.0234 36.8667 18.0234C30.9132 18.0234 26.0869 22.8497 26.0869 28.8033C26.0869 34.7568 30.9132 39.5831 36.8667 39.5831Z",
    fill: "#4C220B"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_866_1533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.2093 26.4903C33.919 23.465 34.7739 21.9524 35.9469 21.563C36.5922 21.3488 37.2874 21.3488 37.9327 21.563C39.1057 21.9524 39.9605 23.465 41.6702 26.4903C43.3799 29.5155 44.2348 31.0281 43.9783 32.2606C43.8372 32.9387 43.4897 33.5537 42.9854 34.0176C42.0688 34.8607 40.3592 34.8607 36.9398 34.8607C33.5204 34.8607 31.8107 34.8607 30.8941 34.0176C30.3899 33.5537 30.0423 32.9387 29.9012 32.2606C29.6448 31.0281 30.4996 29.5155 32.2093 26.4903Z",
    fill: "#FFA774",
    stroke: "#4C220B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9346 30.9648H36.9413",
    stroke: "#4C220B",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9399 28.8412V26.0078",
    stroke: "#4C220B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_866_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 41.7431,
    fill: "white",
    transform: "translate(-0.0600586 0.132812)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_866_1533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(28.4399 19.6328)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndeliveredShipments);
export default __webpack_public_path__ + "static/media/undelivered-shipments.fcb2e03353bbec87d3c9f3681c915565.svg";
export { ForwardRef as ReactComponent };